/** Syncra landing marketing imagery (locale-independent). */

import { MARKETING_TRUSTED_BRAND_OSS_WIDTH, withDemoPreviewOssResize } from '~/utils/demoPreviewMedia.js'

/** Tailwind 需完整类名字面量，禁止模板拼接 col-span / row-start */
const BENTO_COL_SPAN_CLASS = {
  4: 'md:col-span-4',
  8: 'md:col-span-8',
}

const BENTO_ROW_START_CLASS = {
  1: 'md:row-start-1',
  2: 'md:row-start-2',
  3: 'md:row-start-3',
  4: 'md:row-start-4',
  5: 'md:row-start-5',
  6: 'md:row-start-6',
}

/**
 * Bento 12 列网格：按行奇偶交替 4+8 / 8+4
 * - 奇数行（1、3、5…）：左 4 + 右 8
 * - 偶数行（2、4、6…）：左 8 + 右 4
 */
export function getMarketingLandingBentoCellLayout(index) {
  const rowNumber = Math.floor(index / 2) + 1
  const slotInRow = index % 2
  const isOddRow = rowNumber % 2 === 1
  const span = slotInRow === 0
    ? (isOddRow ? 4 : 8)
    : (isOddRow ? 8 : 4)

  return {
    col: BENTO_COL_SPAN_CLASS[span],
    row: BENTO_ROW_START_CLASS[rowNumber] ?? 'md:row-start-1',
    imgClass: span === 4 ? 'group-hover:scale-105' : 'group-hover:scale-[1.02]',
    pad: span === 4 ? 'p-6' : 'p-8',
  }
}

/** 与 Magic Hour lip-sync 页「Trusted by teams at」一致的品牌 Logo（CDN） */
export const marketingLandingTrustedBrands = [
  { id: 'meta', name: 'Meta' },
  { id: 'nba', name: 'NBA' },
  { id: 'loreal', name: "L'Oréal" },
  { id: 'puma', name: 'Puma' },
  { id: 'cisco', name: 'Cisco' },
  { id: 'deel', name: 'Deel' },
  { id: 'shopify', name: 'Shopify' },
  { id: 'decathlon', name: 'Decathlon' },
  { id: 'dallas-mavericks', name: 'Dallas Mavericks' },
  { id: 'pittsburgh-pirates', name: 'Pittsburgh Pirates' },
  { id: 'tala', name: 'Tala' },
  { id: 'dyson', name: 'Dyson' },
  { id: 'dazn', name: 'DAZN' },
  { id: 'wsc-sports', name: 'WSC Sports' },
]

const TRUSTED_BRAND_CDN = 'https://static.lip-sync.ai/lipsync/brandSource'

export function getMarketingLandingTrustedBrandAvifUrl(id) {
  return withDemoPreviewOssResize(
    `${TRUSTED_BRAND_CDN}/${id}.avif`,
    MARKETING_TRUSTED_BRAND_OSS_WIDTH,
  )
}

export const marketingLandingWhyIcons = [
  'face_retouching_natural',
  'groups',
  'videocam',
  'translate',
  'magic_button',
  'sell',
]
